/* Dress Collar — Homepage + PDP interactions.
   Cart AJAX (real Shopify /cart/*.js endpoints) + fabric toggle + PDP variant resolver. */
(function () {
  'use strict';

  var cart = null;

  function moneyFromCents(cents) {
    var dollars = cents / 100;
    return '$' + (cents % 100 === 0 ? dollars.toFixed(0) : dollars.toFixed(2));
  }

  function imageThumb(url) {
    if (!url) return '';
    return url.replace(/\.(jpg|jpeg|png|webp)(\?.*)?$/i, '_200x.$1$2');
  }

  /* ---------- Cart drawer rendering ---------- */
  function renderDrawer(c) {
    if (!c) return;
    cart = c;
    var body = document.querySelector('[data-dc-cart-body]');
    var drawer = document.querySelector('.dc-drawer');
    var foot = drawer ? drawer.querySelector('.dc-drawer-foot') : null;

    document.querySelectorAll('[data-dc-cart-count]').forEach(function (el) {
      el.textContent = c.item_count;
      if (c.item_count === 0) el.setAttribute('hidden', '');
      else el.removeAttribute('hidden');
    });

    if (!body) return;

    if (c.item_count === 0) {
      body.innerHTML =
        '<div class="dc-cart-empty"><span class="dc-serif">Your bag is empty.</span>' +
        '<a class="dc-btn dc-btn-secondary" href="/collections/polos">Shop the collection</a></div>';
      if (foot) foot.remove();
      return;
    }

    var html = '';
    c.items.forEach(function (it) {
      var key = it.key;
      html += '<div class="dc-cart-item" data-dc-key="' + key + '">';
      html += '<div class="dc-ci-img">';
      if (it.featured_image && it.featured_image.url) {
        html += '<img src="' + imageThumb(it.featured_image.url) + '" alt="" width="74" height="88" loading="lazy">';
      }
      html += '</div><div>';
      html += '<div class="dc-ci-name">' + it.product_title + '</div>';
      if (it.variant_title && it.variant_title !== 'Default Title') {
        html += '<div class="dc-ci-meta">' + it.variant_title + '</div>';
      }
      html += '<div class="dc-ci-qty">';
      html += '<button type="button" data-dc-qty="-1" data-dc-key="' + key + '" data-dc-current-qty="' + it.quantity + '" aria-label="Decrease">−</button>';
      html += '<span>' + it.quantity + '</span>';
      html += '<button type="button" data-dc-qty="1" data-dc-key="' + key + '" data-dc-current-qty="' + it.quantity + '" aria-label="Increase">+</button>';
      html += '</div>';
      html += '<button type="button" class="dc-ci-remove" data-dc-remove data-dc-key="' + key + '">Remove</button>';
      html += '</div>';
      html += '<div class="dc-ci-price">' + moneyFromCents(it.final_line_price) + '</div>';
      html += '</div>';
    });
    body.innerHTML = html;

    // Foot — recreate if missing
    var existingFoot = drawer.querySelector('.dc-drawer-foot');
    var subtotalStr = moneyFromCents(c.total_price);
    var remaining = 15000 - c.total_price;
    var note = remaining > 0
      ? 'Add ' + moneyFromCents(remaining) + ' for complimentary shipping.'
      : 'Complimentary shipping unlocked.';
    var footHtml =
      '<div class="dc-drawer-foot">' +
      '<div class="dc-totals"><span class="dc-lbl">Subtotal</span><b data-dc-subtotal>' + subtotalStr + '</b></div>' +
      '<p class="dc-ship-note" data-dc-ship-note>' + note + '</p>' +
      '<a class="dc-btn dc-btn-primary dc-btn-block" href="/checkout">Checkout <span class="dc-arrow">→</span></a>' +
      '</div>';
    if (existingFoot) existingFoot.outerHTML = footHtml;
    else drawer.insertAdjacentHTML('beforeend', footHtml);
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderDrawer(c); return c; });
  }

  // Key-based change. `id` accepts a line-item key (preferred — never shifts
  // when other items are removed) or a variant id.
  function changeItem(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    })
      .then(function (r) { return r.json(); })
      .then(renderDrawer);
  }

  function openDrawer() {
    // Prefer the shared open routine (sets inline styles + classes uniformly).
    if (window.dcCart && typeof window.dcCart.open === 'function') {
      window.dcCart.open();
      return;
    }
    var drawer = document.querySelector('.dc-drawer');
    var scrim = document.querySelector('.dc-scrim');
    if (drawer) drawer.classList.add('dc-open');
    if (scrim) {
      scrim.classList.add('dc-open');
      scrim.style.opacity = '1';
      scrim.style.pointerEvents = 'auto';
    }
    document.body.style.overflow = 'hidden';
  }

  function addAndOpen(variantId, qty) {
    qty = qty || 1;
    var added = false;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      cache: 'no-store',
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] }),
    })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (j) {
            throw new Error(j.description || j.message || 'Add failed: ' + r.status);
          });
        }
        return r.json();
      })
      .then(function (addResp) {
        // Confirm Shopify actually added a line. Without this check a 200 with
        // an empty body could trick us into opening an empty drawer.
        var addedItems = (addResp && addResp.items) ||
          (addResp && addResp.id ? [addResp] : []);
        if (!addedItems.length || !addedItems[0].id) {
          throw new Error('Add returned 200 but no item in response');
        }
        added = true;
        return fetchCart().catch(function (e) {
          console.warn('[dc] cart refresh after add failed:', e && e.message);
        });
      })
      .catch(function (err) {
        console.warn('[dc] add-to-cart path:', err && err.message);
      })
      .then(function () {
        // try/finally semantics — drawer opens only when add actually succeeded.
        if (added) {
          try { openDrawer(); } catch (e) { console.warn('[dc] open failed:', e); }
        }
      });
  }

  // Resolve a buyable variant id for a product handle by hitting the live JSON.
  // Used as a safety net when the SSR-rendered data-dc-quick-add is empty / 0 /
  // points at a now-stale variant.
  function resolveFirstAvailableVariantId(handle) {
    if (!handle) return Promise.resolve(null);
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('product ' + r.status); return r.json(); })
      .then(function (p) {
        var vs = (p && p.variants) || [];
        var pick = vs.find ? vs.find(function (v) { return v.available; }) : null;
        if (!pick && vs.length) pick = vs[0];
        return pick ? pick.id : null;
      })
      .catch(function (e) {
        console.warn('[dc] resolveFirstAvailableVariantId failed for', handle, e && e.message);
        return null;
      });
  }

  // Delegated handlers
  document.addEventListener('click', function (e) {
    var qBtn = e.target.closest && e.target.closest('[data-dc-qty]');
    if (qBtn) {
      e.preventDefault();
      var key = qBtn.dataset.dcKey;
      var delta = parseInt(qBtn.dataset.dcQty, 10);
      if (!key) return;
      // Prefer the button's own data-dc-current-qty (set by both SSR Liquid and
      // JS rendering); fall back to in-memory cart.
      var curQty = parseInt(qBtn.dataset.dcCurrentQty, 10);
      if (isNaN(curQty) && cart && cart.items) {
        var match = cart.items.find ? cart.items.find(function (i) { return i.key === key; }) : null;
        if (match) curQty = match.quantity;
      }
      if (isNaN(curQty)) curQty = 1;
      changeItem(key, Math.max(0, curQty + delta));
      return;
    }
    var rBtn = e.target.closest && e.target.closest('[data-dc-remove]');
    if (rBtn) {
      e.preventDefault();
      var rkey = rBtn.dataset.dcKey;
      if (rkey) changeItem(rkey, 0);
      return;
    }
    var qa = e.target.closest && e.target.closest('[data-dc-quick-add]');
    if (qa) {
      e.preventDefault();
      e.stopPropagation();
      var vid = parseInt(qa.dataset.dcQuickAdd, 10);
      var handle = qa.dataset.dcQuickHandle;
      if (vid > 0) {
        addAndOpen(vid);
      } else {
        // SSR id was empty / 0 / NaN — go fetch a live one for this handle.
        resolveFirstAvailableVariantId(handle).then(function (live) {
          if (live) addAndOpen(live);
          else console.warn('[dc] quick-add: no buyable variant for', handle);
        });
      }
      return;
    }
  });

  /* ---------- PDP ----------
     The Liquid-embedded variants JSON can be edge-cached and stale (e.g.
     available:false from before inventoryPolicy=CONTINUE took effect). We use
     the live /products/{handle}.js endpoint as the single source of truth and
     only fall back to the embedded JSON if the fetch fails. */
  var pdp = document.querySelector('[data-dc-pdp]');
  if (pdp) {
    var productHandle = pdp.dataset.productHandle || '';
    var variants = [];
    var state = { fabric: null, size: null };

    // Resolve variant by matching the chosen fabric AND size against whichever
    // option position they occupy (Shopify product options can be in any order).
    function matchesOpt(v, value) {
      return v.option1 === value || v.option2 === value || v.option3 === value;
    }
    function findVariant() {
      return variants.find(function (v) {
        var fOK = state.fabric ? matchesOpt(v, state.fabric) : true;
        var sOK = state.size ? matchesOpt(v, state.size) : true;
        return fOK && sOK;
      });
    }
    function isSizeAvailable(sizeVal, fabricVal) {
      return variants.some(function (v) {
        return matchesOpt(v, sizeVal) && (!fabricVal || matchesOpt(v, fabricVal)) && v.available;
      });
    }
    function formatMoney(cents) {
      var d = cents / 100;
      return '$' + (cents % 100 === 0 ? d.toFixed(0) : d.toFixed(2));
    }

    function pickDefaultSize() {
      // Pre-fetch: pick M (or first) as active so the chip row isn't blank.
      var sizeBtns = pdp.querySelectorAll('.dc-sizes .dc-size');
      var sizes = Array.prototype.map.call(sizeBtns, function (b) { return b.dataset.sizeValue; });
      if (!state.size || sizes.indexOf(state.size) === -1) {
        state.size = sizes.indexOf('M') !== -1 ? 'M' : (sizes[0] || null);
      }
      sizeBtns.forEach(function (b) {
        b.classList.toggle('dc-on', b.dataset.sizeValue === state.size);
      });
    }

    function refreshSizes() {
      // Only mark sold-out / re-pick a size once we have live data — otherwise
      // every chip would flash as sold-out for the duration of the fetch.
      if (!variants.length) { pickDefaultSize(); return; }
      var sizeBtns = pdp.querySelectorAll('.dc-sizes .dc-size');
      var available = [];
      sizeBtns.forEach(function (b) {
        var s = b.dataset.sizeValue;
        if (isSizeAvailable(s, state.fabric)) {
          b.classList.remove('dc-soldout');
          b.removeAttribute('aria-disabled');
          available.push(s);
        } else {
          b.classList.add('dc-soldout');
          b.setAttribute('aria-disabled', 'true');
        }
      });
      if (!state.size || available.indexOf(state.size) === -1) {
        state.size = available.indexOf('M') !== -1 ? 'M' : (available[0] || null);
      }
      sizeBtns.forEach(function (b) {
        b.classList.toggle('dc-on', b.dataset.sizeValue === state.size);
      });
    }

    function updateVariant() {
      // Before live data lands, keep the SSR-rendered price + Add-to-bag intact
      // so the user always has clickable defaults from a first paint.
      if (!variants.length) return;
      var v = findVariant();
      var vidEl = pdp.querySelector('[data-dc-variant-id]');
      var priceEl = pdp.querySelector('[data-dc-pdp-price]');
      var addPrice = pdp.querySelector('[data-dc-add-price]');
      var addBtn = pdp.querySelector('[data-dc-add-btn]');
      var priceStr = v ? formatMoney(v.price) : '—';
      if (v && vidEl) vidEl.value = v.id;
      if (priceEl) priceEl.textContent = priceStr;
      if (addPrice) addPrice.textContent = priceStr;
      if (addBtn) {
        if (v && v.available) {
          addBtn.removeAttribute('disabled');
          if (addBtn.firstChild && addBtn.firstChild.nodeType === 3) addBtn.firstChild.textContent = 'Add to bag — ';
        } else {
          addBtn.setAttribute('disabled', '');
          if (addBtn.firstChild && addBtn.firstChild.nodeType === 3) addBtn.firstChild.textContent = 'Sold out — ';
        }
      }
    }

    // Initial state — fabric from SSR (first chip is server-marked .dc-on); size resolved by JS.
    var firstFabricOn = pdp.querySelector('[data-dc-fabric-seg] .dc-on');
    if (firstFabricOn) state.fabric = firstFabricOn.dataset.fabricValue;

    function loadLiveProduct() {
      if (!productHandle) return Promise.resolve();
      return fetch('/products/' + productHandle + '.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { if (!r.ok) throw new Error('product ' + r.status); return r.json(); })
        .then(function (data) {
          if (data && data.variants && data.variants.length) {
            variants = data.variants;
          }
        })
        .catch(function (e) {
          console.warn('[dc] live product fetch failed, falling back to embedded JSON:', e && e.message);
          var variantsJson = pdp.querySelector('[data-dc-variants]');
          if (variantsJson) {
            try { variants = JSON.parse(variantsJson.textContent); } catch (err) {}
          }
        });
    }

    // Immediate: pick a default size so the chip row isn't blank during fetch.
    pickDefaultSize();
    // Then load live data and switch over to it as source of truth.
    loadLiveProduct().then(function () {
      refreshSizes();
      updateVariant();
    });

    // Fabric segmented — exactly one active, re-evaluates sizes + variant.
    pdp.querySelectorAll('[data-dc-fabric-seg] button').forEach(function (b) {
      b.addEventListener('click', function () {
        pdp.querySelectorAll('[data-dc-fabric-seg] button').forEach(function (x) { x.classList.remove('dc-on'); });
        b.classList.add('dc-on');
        state.fabric = b.dataset.fabricValue;
        var f = b.dataset.f;
        var note = pdp.querySelector('[data-dc-fabric-note]');
        var val = pdp.querySelector('[data-dc-fabric-val]');
        var stageTag = pdp.querySelector('[data-dc-stage-tag]');
        if (note && window.DC_FABRIC_NOTES) note.innerHTML = window.DC_FABRIC_NOTES[f] || '';
        if (val && window.DC_FABRIC_VAL) val.textContent = window.DC_FABRIC_VAL[f] || '';
        var tEl = b.querySelector('.dc-t');
        if (stageTag && tEl) stageTag.textContent = tEl.textContent;
        refreshSizes();
        updateVariant();
      });
    });

    // Sizes — delegated so we can pick a size that *became* available after a
    // fabric switch (handler isn't bound at SSR-soldout time).
    pdp.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.dc-sizes .dc-size');
      if (!b) return;
      if (b.classList.contains('dc-soldout')) { e.preventDefault(); return; }
      pdp.querySelectorAll('.dc-sizes .dc-size').forEach(function (x) { x.classList.remove('dc-on'); });
      b.classList.add('dc-on');
      state.size = b.dataset.sizeValue;
      updateVariant();
    });

    // Thumb clicks
    pdp.querySelectorAll('[data-dc-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var idx = parseInt(t.dataset.dcThumb, 10);
        pdp.querySelectorAll('[data-dc-thumb]').forEach(function (x) { x.classList.remove('dc-on'); });
        t.classList.add('dc-on');
        pdp.querySelectorAll('[data-dc-stage-img]').forEach(function (img) {
          img.classList.toggle('dc-on', parseInt(img.dataset.dcStageImg, 10) === idx);
        });
      });
    });

    // Accordion
    pdp.querySelectorAll('[data-dc-acc]').forEach(function (item) {
      var q = item.querySelector('.dc-acc-q');
      var a = item.querySelector('.dc-acc-a');
      function set(open) {
        item.classList.toggle('dc-open', open);
        if (a) a.style.maxHeight = open ? (a.scrollHeight + 'px') : '0px';
      }
      set(item.classList.contains('dc-open'));
      if (q) q.addEventListener('click', function () { set(!item.classList.contains('dc-open')); });
    });

    // Save-for-later affordance
    var wish = pdp.querySelector('[data-dc-wish]');
    if (wish) {
      var orig = wish.textContent;
      wish.addEventListener('click', function () {
        wish.textContent = 'Saved ✓';
        setTimeout(function () { wish.textContent = orig; }, 1600);
      });
    }

    // PDP form submit → AJAX add. Find via class because the {% form %} tag
    // doesn't pass through arbitrary data-attributes.
    var form = pdp.querySelector('form.dc-pdp-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = findVariant();
        if (v && v.available) addAndOpen(v.id);
      });
    }
  }

  /* ---------- Homepage fabric toggle ---------- */
  var fabricToggle = document.querySelector('[data-dc-fabric-toggle]');
  if (fabricToggle) {
    var fabricMedia = document.querySelector('.dc-fabric-media');
    fabricToggle.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var f = b.dataset.f;
        fabricToggle.dataset.f = f;
        if (fabricMedia) fabricMedia.dataset.f = f;
        fabricToggle.querySelectorAll('button').forEach(function (x) { x.classList.toggle('on', x.dataset.f === f); });
        ['hand', 'for', 'weight'].forEach(function (k) {
          document.querySelectorAll('[data-dc-fabric-' + k + '-ath]').forEach(function (el) { el.hidden = f !== 'athletic'; });
          document.querySelectorAll('[data-dc-fabric-' + k + '-dress]').forEach(function (el) { el.hidden = f !== 'dress'; });
        });
        var tag = document.querySelector('[data-dc-fabric-tag]');
        if (tag) tag.textContent = f === 'athletic' ? 'Athletic' : 'Dress';
      });
    });
  }

  // Sync the drawer to the live cart on load (in case Liquid render was stale)
  fetchCart().catch(function () {});
})();
